import {toLower, startCase} from 'lodash';
import {I18n} from 'react-redux-i18n';

export default oer => {
  const lowerOer = toLower(oer);
  const translatedOer = I18n.t(`filter.oer.${lowerOer}`);
  if (translatedOer !== lowerOer) {
    return translatedOer;
  }

  // it doesn't have a translation
  if (lowerOer === 'stability_control_7') {
    return 'Forward Collision Warning';
  }
  return startCase(lowerOer);
};
